<template>
    <div class="custom-week">
        <div class="items-week" >
            <div class="item-week my-cursor"
                 :class="{
                    'icon-option-true': week === index,
                    'icon-option-false': week !== index,
                 }"
                 @click.stop="submit(index)"
                 v-for="(item, index) in items">{{ item }}</div>
        </div>
        <div class="skip-state">
            <div class="text-skip">智能跳过法定节假日</div>
            <div class="my-cursor"
                 :class="{
                'icon-switch-false': !skipHolidaysState,
                'icon-switch-true': skipHolidaysState,
            }" @click.stop="saveSkipState">
            </div>
        </div>
    </div>
</template>

<script>
import ScrollModule from "@/pages/List/MatterInfo/ScrollModule";
export default {
    name: "RepeatWeek",
    components: {
        ScrollModule
    },
    data(){
        return {
            week: 0,
            items: ["一", "二", "三", "四", "五", "六", "日"],
        }
    },
    props:{
        repeatInfo: {
            type: String,
            default: "",
        },
        skipHolidaysState: {
            type: Boolean,
            default: 0,
        },
    },
    methods: {
        submit: function(index){
            this.week = index;
            const repeatInfo = (this.week + 1).toString();
            this.$emit("submitEvent", {repeatType: "custom_week", repeatCycle: 1, repeatInfo: repeatInfo});
        },
        saveSkipState: function(){
            this.$emit("submitSkipState", !this.skipHolidaysState);
        },
    },
    mounted(){
        if(this.repeatInfo === ""){
            let week = new Date().getDay();
            if(week === 0){
                week = 7
            }
            this.week = week - 1;
        }else{
            this.week = parseInt(this.repeatInfo) - 1;
        }
    },
}
</script>

<style scoped>
div.custom-week{
    width: 100%;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    padding: 0.3rem 0.2rem;
    box-sizing: border-box;
    margin-top: 0.2rem;
}
div.items-week{
    width: 100%;
    display: flex;
    justify-content: space-between;
}
div.item-week{
    width: 0.3rem;
    height: 0.3rem;
    font-weight: bold;
    font-size: 0.15rem;
    color: #000000;
    line-height: 0.35rem;
    text-align: center;
}
div.icon-option-true{
    background: url("../../../assets/images/Public/icon-option-true.png");
    background-size: cover;
}
div.icon-option-false{
    background: url("../../../assets/images/Public/icon-option-false.png");
    background-size: cover;
}
div.skip-state{
    width: 100%;
    height: 0.36rem;
    background: rgba(252, 132, 112, 0.3);
    border-radius: 0.06rem;
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.12rem;
}
div.text-skip{
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}
div.icon-switch-true, div.icon-switch-false{
    width: 0.5rem;
    height: 0.24rem;
}
div.icon-switch-true{
    background: url("../../../assets/images/List/icon-switch-true.png");
    background-size: cover;
}
div.icon-switch-false{
    background: url("../../../assets/images/List/icon-switch-false.png");
    background-size: cover;
}

</style>